import { render, staticRenderFns } from "./pieData.vue?vue&type=template&id=656a3bd8&"
import script from "./pieData.vue?vue&type=script&lang=js&"
export * from "./pieData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports